import React from "react";
import AppRouter from "./router/router";
import useResponsiveScaling from "./utils/useResponsiveScaling";

import "leaflet/dist/leaflet.css";
import "./App.css";
import "./i18n";

function App() {
  const { style } = useResponsiveScaling(600);

  return (
    <div style={style}>
      <AppRouter />
    </div>
  );
}

export default App;
